import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import {
  CloseIcon,
  TickCircleIcon,
  TimeIcon,
  MealIcon,
  BedIcon,
  WiFiIcon,
} from "../../../helper/HwIcon";
import { formatePriceFn, formatPrice } from "../../../helper/commonFunction";

const policyIcon = (label = "") => {
  const l = String(label).toLowerCase();
  if (l.includes("check-in") || l.includes("check-out") || l.includes("checkin") || l.includes("checkout") || l.includes("time"))
    return <TimeIcon />;
  if (l.includes("internet") || l.includes("wifi") || l.includes("wi-fi")) return <WiFiIcon />;
  if (l.includes("meal") || l.includes("breakfast")) return <MealIcon />;
  if (l.includes("bed")) return <BedIcon />;
  return null;
};
const policyText = (policy = {}) => {
  const label = String(policy?.label || "");
  const desc = policy?.description || "";
  if (/check-?in/i.test(label)) return `Check-in: ${desc}`;
  if (/check-?out/i.test(label)) return `Check-out: ${desc}`;
  return desc;
};

const RDX_STYLES = `
.hw-rdx--overlay{position:fixed;inset:0;z-index:2000;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(15,23,42,.55);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);overflow-y:auto;animation:hwRdxFade .18s ease;}
.hw-rdx--dialog{width:100%;max-width:1100px;max-height:88vh;display:flex;flex-direction:column;background:#fff;border-radius:12px;box-shadow:0 24px 60px rgba(15,23,42,.28);overflow:hidden;animation:hwRdxPop .2s cubic-bezier(.2,.8,.3,1);}
@keyframes hwRdxFade{from{opacity:0}to{opacity:1}}
@keyframes hwRdxPop{from{opacity:0;transform:translateY(12px) scale(.98)}to{opacity:1;transform:none}}
.hw-rdx--head{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;padding:20px 24px;border-bottom:1px solid #eef1f6;}
.hw-rdx--title{font-size:19px;font-weight:700;color:#0f172a;line-height:1.3;text-transform:capitalize;}
.hw-rdx--sub{margin-top:4px;font-size:13px;font-weight:500;color:#64748b;}
.hw-rdx--close{flex:none;width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;border:none;border-radius:50%;background:#f1f5f9;color:#475569;cursor:pointer;transition:background .15s;}
.hw-rdx--close:hover{background:#e2e8f0;}
.hw-rdx--close svg{width:16px;height:16px;}
.hw-rdx--body{padding:20px 24px 24px;overflow-y:auto;display:flex;flex-direction:column;gap:16px;}
.hw-rdx--sec{display:flex;flex-direction:column;}
.hw-rdx--secTtl{font-size:14px;font-weight:600;font-family:DM Sans;color:#000;margin-bottom:8px;}
.hw-rdx--chips{display:flex;flex-wrap:wrap;gap:8px;}
.hw-rdx--chip{display:inline-flex;align-items:center;gap:6px;background:#f1f5f9;color:#334155;font-size:13px;font-weight:600;padding:7px 13px;border-radius:999px;text-transform:capitalize;}
.hw-rdx--chip svg{width:15px;height:15px;color:#3264FF;flex:none;}
.hw-rdx--incGrid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:2px;}
.hw-rdx--inc{display:flex;align-items:flex-start;gap:9px;font-size:13px;font-weight:500;color:#334155;line-height:1.45;}
.hw-rdx--inc svg{width:18px;height:18px;flex:none;color:#1d9e75;margin-top:1px;}
.hw-rdx--rows{display:flex;flex-direction:column;gap:12px;}
.hw-rdx--row{display:flex;align-items:flex-start;gap:10px;font-size:14px;font-weight:500;color:#475569;line-height:1.5;}
.hw-rdx--row svg{width:19px;height:19px;flex:none;color:#3264FF;margin-top:1px;}
.hw-rdx--row span strong{color:#1f2a44;}
.hw-rdx--cancel{display:flex;flex-direction:column;gap:6px;}
.hw-rdx--cancelRow{display:flex;align-items:center;gap:8px;font-size:14px;font-weight:500;line-height:1.5;}
.hw-rdx--cancelRow.is-free{color:#137333;}
.hw-rdx--cancelRow.is-charge{color:#b42318;}
.hw-rdx--note{display:flex;align-items:flex-start;gap:9px;background:#fff7e6;border:1px solid #ffe3a3;border-radius:12px;padding:12px 14px;font-size:13.5px;font-weight:500;color:#8a5a00;line-height:1.5;max-width:250px;}
.hw-rdx--hrNote{background:#eff4ff;border:1px solid #d6e2ff;border-radius:12px;padding:14px 16px;font-size:14px;font-weight:500;color:#3a4a6b;line-height:1.5;}
.hw-rdx--empty{font-size:14px;color:#94a3b8;text-align:center;padding:16px 0;}
.hw-rdx--dialog.is-compact{max-width:600px;}
.hw-rdx--dialog.is-compact .hw-rdx--incGrid{grid-template-columns:repeat(2,minmax(0,1fr));}
@media (max-width:520px){
  .hw-rdx--incGrid{grid-template-columns:1fr;}
  .hw-rdx--head{padding:16px 18px;}
  .hw-rdx--body{padding:16px 18px 20px;}
  .hw-rdx--title{font-size:17px;}
}
`;

export const RoomDetailsPopup = ({
  show,
  onClose,
  title,
  features = [],
  guestPolicies = [],
  agentActiveCurrency,
  displayPrice,
  isHotelRack = false,
  meal = "",
  isCateory = false,
  roomExtras = {},
  spotTax = null,
  inclusions = [],
  compact = false,
}) => {
  let Policies = guestPolicies?.filter((p) => p?.label !== 'Cancellation Policy' && p?.label !== 'Policy')
  let cancelData = guestPolicies?.filter((p) => p?.label == 'Cancellation Policy' || p?.label === 'Policy')
  const categoryData = guestPolicies?.filter((p) => p?.label !== 'Meal' && p?.label !== 'Cancellation Policy' &&   p?.label !== 'Policy')
  const mealPolicies = (guestPolicies || []).filter((p) =>
    /meal|breakfast|board|room only/i.test(`${p?.label || ""} ${p?.description || ""}`)
  );
  // Lock background scroll while the popup is open.
  useEffect(() => {
    if (!show) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [show]);

  if (!show) return null;

  const mealSub = !isHotelRack && !isCateory
    ? (mealPolicies?.[0]?.description || meal || "")
    : "";
  const rows = isCateory ? categoryData : Policies;
  const hasExtras = isCateory && (roomExtras?.bedConfig || roomExtras?.beddingType || roomExtras?.miscNote || spotTax?.amount > 0);
  const hasInclusions = Array.isArray(inclusions) && inclusions.length > 0;
  const nothing = !isHotelRack
    && (!features || features.length === 0)
    && !hasInclusions
    && (!rows || rows.length === 0)
    && !hasExtras
    && (isCateory || !cancelData || cancelData.length === 0);

  return createPortal(
    <>
      <style>{RDX_STYLES}</style>
      <div className="hw-rdx--overlay" onClick={onClose}>
        <div className={`hw-rdx--dialog${compact ? " is-compact" : ""}`} role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()} style={compact ? { maxWidth: 560 } : undefined}>
          <div className="hw-rdx--head">
            <div>
              <div className="hw-rdx--title">{title || "Room details"}</div>
              {/* {mealSub ? <div className="hw-rdx--sub">{mealSub}</div> : null} */}
            </div>
            <button type="button" className="hw-rdx--close" onClick={onClose} aria-label="Close">
              <CloseIcon />
            </button>
          </div>

          <div className="hw-rdx--body">
            {isHotelRack ? (
              <>
                {(mealPolicies?.length > 0 || meal) && (
                  <div className="hw-rdx--sec">
                    <div className="hw-rdx--secTtl">Meal plan</div>
                    <div className="hw-rdx--chips">
                      {mealPolicies?.length > 0 ? (
                        mealPolicies.map((p, i) => (
                          <span className="hw-rdx--chip" key={i}><MealIcon />{p?.description || p?.label}</span>
                        ))
                      ) : (
                        <span className="hw-rdx--chip"><MealIcon />{meal}</span>
                      )}
                    </div>
                  </div>
                )}
                <div className="hw-rdx--hrNote">
                  To see the cancellation policy and other details, please continue to checkout.
                </div>
              </>
            ) : (
              <>
                {features?.length > 0 && (
                  <div className="hw-rdx--sec">
                    <div className="hw-rdx--secTtl">Room highlights</div>
                    <div className="hw-rdx--chips">
                      {features.map((f, i) => (
                        <span className="hw-rdx--chip" key={i}><TickCircleIcon />{f?.name}</span>
                      ))}
                    </div>
                  </div>
                )}

                {hasInclusions && (
                  <div className="hw-rdx--sec">
                    <div className="hw-rdx--secTtl">What's included</div>
                    <div className="hw-rdx--incGrid">
                      {inclusions.map((inc, i) => (
                        <div className="hw-rdx--inc" key={i}><TickCircleIcon /><span>{inc}</span></div>
                      ))}
                    </div>
                  </div>
                )}

                {rows?.length > 0 && (
                  <div className="hw-rdx--sec">
                    <div className="hw-rdx--secTtl">{isCateory ? "Room details" : "Good to know"}</div>
                    <div className="hw-rdx--rows">
                      {rows.map((p, i) => (
                        <div className="hw-rdx--row" key={i}>
                          {policyIcon(p?.label)}
                          <span dangerouslySetInnerHTML={{ __html: policyText(p) }} />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {hasExtras && (
                  <div className="hw-rdx--sec">
                    <div className="hw-rdx--secTtl">Extras</div>
                    {(roomExtras?.bedConfig || roomExtras?.beddingType || roomExtras?.miscNote) && (
                      <div className="hw-rdx--chips" style={{ marginBottom: spotTax?.amount > 0 ? 12 : 0 }}>
                        {roomExtras?.bedConfig && <span className="hw-rdx--chip">{roomExtras.bedConfig}</span>}
                        {roomExtras?.beddingType && roomExtras?.beddingType !== roomExtras?.bedConfig && (
                          <span className="hw-rdx--chip">{roomExtras.beddingType}</span>
                        )}
                        {roomExtras?.miscNote && <span className="hw-rdx--chip">{roomExtras.miscNote}</span>}
                      </div>
                    )}
                    {spotTax?.amount > 0 && (
                      <div className="hw-rdx--note">
                        +{Number(spotTax.amount).toFixed(2)} {spotTax.currency} payable at the hotel
                      </div>
                    )}
                  </div>
                )}

                {!isCateory && cancelData?.length > 0 && (
                  <div className="hw-rdx--sec">
                    <div className="hw-rdx--secTtl">Cancellation</div>
                    <div className="hw-rdx--cancel">
                      {cancelData.map((p, i) => {
                        if (p?.freeCancellation) {
                          return (
                            <div className="hw-rdx--cancelRow is-free" key={i}>
                              <span dangerouslySetInnerHTML={{ __html: policyText(p) }} />
                            </div>
                          );
                        }
                        return (
                          <div className="hw-rdx--cancelRow is-charge" key={i}>
                            <span>{p?.description}</span>
                            {p?.amount ? <span>{formatePriceFn(agentActiveCurrency, formatPrice(p?.amount, true, true), displayPrice)}</span> : null}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {nothing && <div className="hw-rdx--empty">No additional details available</div>}
              </>
            )}
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default RoomDetailsPopup;
